export default __webpack_public_path__ + "static/media/CrossBlack.fa788bfc.svg";